<template>
    <base-modal title="Topic settings" max-height="50rem" :visible="true" @close="$emit('close')">
        <topics-form
            :loading="update.loading"
            :init_data="copy(topic)"
            :show_permission="!topic.is_general"
            :space="space"
            :topic="topic"
            @toggle_private="toggle_private"
            @cancel="$emit('close')"
            @submit="submit"/>
    </base-modal>
</template>

<script>
import { mapState } from 'vuex';
import TopicsForm from './TopicsForm.vue';

export default {
    name: 'TopicsUpdateModal',
    components: { TopicsForm },
    props: ['space', 'topic'],
    computed: mapState('topics', ['update']),
    methods: {
        async submit(data) {
            await this.save(data);
            this.$emit('close');
            await this.$store.dispatch('topics/list', { space_id: this.space.id });
        },
        async toggle_private() {
            const value = !this.topic.is_private;
            await this.save({ is_private: value });
            this.$store.commit('topics/toggle_private', { id: this.topic.id, value });
        },
        async save(data) {
            await this.$store.dispatch('topics/update', {
                space_id: this.space.id,
                topic_id: this.topic.id,
                data,
            });
        },
    },
};
</script>
